import { SIMPLE, SIMPLE_SECRET_WORD } from '../../../constants/tasksTypes';
import { useQuestSubType } from './useQuestSubType';

export const useVisibleExtraButton = ({ quest }) => {
  const { type, isComplete, isCollected } = quest;

  const subType = useQuestSubType({ quest });

  return {
    [SIMPLE]() {
      return subType === SIMPLE_SECRET_WORD && !isComplete && !isCollected;
    },
  }[type]?.();
};
